import { useBusEmitterListener } from "./index";

const documentFinishedLoadingEvent = Symbol("bridge:documentFinishedLoadingEvent");
const {
  emitter: documentFinishedLoadingFn,
  listener: onDocumentFinishedLoadingFn,
} = useBusEmitterListener<void>(documentFinishedLoadingEvent);

export function documentFinishedLoading() {
  documentFinishedLoadingFn();
}

export const onDocumentFinishedLoading = onDocumentFinishedLoadingFn;

const documentStartedLoadingEvent = Symbol("bridge:documentStartedLoadingEvent");
const {
  emitter: documentStartedLoadingFn,
  listener: onDocumentStartedLoadingFn,
} = useBusEmitterListener<void>(documentStartedLoadingEvent);

export function documentStartedLoading() {
  documentStartedLoadingFn();
}

export const onDocumentStartedLoading = onDocumentStartedLoadingFn;
